module.exports = __webpack_public_path__ + "static/media/hikingbook.14d6ead7.webp";